import React, { useState, useEffect } from "react";
import axios from "axios";

const Product = () => {
  const [form, setForm] = useState({
    productName: "",
    qty: "",
    isCount: "",
    isActive: "",
    isEmailMandatory: "",
    isDOBMandatory: "",
    isCVVMandatory: "",
    // productPrice: "0",
    // offerPrice: "0",
  });

  const [products, setProducts] = useState([]);
  const [selected, setSelected] = useState([]);
  const [editId, setEditId] = useState(null);

  // ✅ Fetch all products
  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const res = await axios.get("https://crm-server-htk6.vercel.app/api/products");
      setProducts(res.data);
    } catch (err) {
      console.error("⚠️ Error fetching products:", err);
    }
  };

  // ✅ Handle form input
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value,
    });
  };

//   const formatPayload = (form) => ({
//   ...form,
//   isCount: form.isCount === "true",
//   isEmailMandatory: form.isEmailMandatory === "Yes",
//   isDOBMandatory: form.isDOBMandatory === "Yes",
//   isCVVMandatory: form.isCVVMandatory === "Yes",
// });

const handleSave = async () => {
  if (!form.productName || !form.qty) {
    alert("⚠️ Please fill Product Name and QTY");
    return;
  }

  const payload = {
    ...form,
    isCount: form.isCount === "Yes",
    isEmailMandatory: form.isEmailMandatory === "Yes",
    isDOBMandatory: form.isDOBMandatory === "Yes",
    isCVVMandatory: form.isCVVMandatory === "Yes",
  };

  try {
    const res = await axios.post("https://crm-server-htk6.vercel.app/api/products", payload);
    if (res.data.success) {
      alert("✅ Product saved successfully");
      fetchProducts();
      resetForm();
    }
  } catch (err) {
    console.error("❌ Error saving product:", err);
  }
};




  // // ✅ Save new product
  // const handleSave = async () => {
  //   if (!form.productName || !form.qty) {
  //     alert("⚠️ Please fill Product Name and QTY");
  //     return;
  //   }
  //   try {
  //     const res = await axios.post("https://crm-server-htk6.vercel.app/api/products", form);
  //     if (res.data.success) {
  //       alert("✅ Product saved successfully");
  //       fetchProducts();
  //       resetForm();
  //     }
  //   } catch (err) {
  //     console.error("❌ Error saving product:", err);
  //   }
  // };

  // ✅ Start editing
  // const handleEdit = (p) => {
  //   setForm({
  //     productName: p.productName,
  //     qty: p.qty,
  //     isCount: p.isCount,
  //     isActive: p.isActive,
  //     isEmailMandatory: p.isEmailMandatory,
  //     isDOBMandatory: p.isDOBMandatory,
  //     isCVVMandatory: p.isCVVMandatory,
  //     // productPrice: p.productPrice,
  //     // offerPrice: p.offerPrice,
  //   });
  //   setEditId(p._id);
  //   window.scrollTo({ top: 0, behavior: "smooth" });
  // };



const handleEdit = (p) => {
  setForm({
    productName: p.productName || "",
    qty: p.qty || "",
    isActive: p.isActive || "",
    isCount: p.isCount ? "Yes" : "No", // ✅ Fix here
    isEmailMandatory: p.isEmailMandatory ? "Yes" : "No",
    isDOBMandatory: p.isDOBMandatory ? "Yes" : "No",
    isCVVMandatory: p.isCVVMandatory ? "Yes" : "No",
  });
  setEditId(p._id);
  window.scrollTo({ top: 0, behavior: "smooth" });
};



  // ✅ Update product
  // const handleUpdate = async () => {
  //   if (!form.productName || !form.qty) {
  //     alert("⚠️ Please fill Product Name and QTY");
  //     return;
  //   }
  //   try {
  //     await axios.put(`https://crm-server-htk6.vercel.app/api/products/${editId}`, form);
  //     alert("✨ Product updated successfully");
  //     fetchProducts();
  //     resetForm();
  //   } catch (err) {
  //     console.error("❌ Error updating product:", err);
  //   }
  // };


const handleUpdate = async () => {
  if (!form.productName || !form.qty) {
    alert("⚠️ Please fill Product Name and QTY");
    return;
  }

  const payload = {
    ...form,
    isCount: form.isCount === "Yes",
    isEmailMandatory: form.isEmailMandatory === "Yes",
    isDOBMandatory: form.isDOBMandatory === "Yes",
    isCVVMandatory: form.isCVVMandatory === "Yes",
  };

  try {
    await axios.put(`https://crm-server-htk6.vercel.app/api/products/${editId}`, payload);
    alert("✨ Product updated successfully");
    fetchProducts();
    resetForm();
  } catch (err) {
    console.error("❌ Error updating product:", err);
  }
};


  // ✅ Reset form
  const resetForm = () => {
    setForm({
      productName: "",
      qty: "",
      isCount: "",
      isActive: "",
      isEmailMandatory: "",
      isDOBMandatory: "",
      isCVVMandatory: "",
      // productPrice: "0",
      // offerPrice: "0",
    });
    setEditId(null);
  };

  // ✅ Toggle selection
  const toggleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((s) => s !== id) : [...prev, id]
    );
  };

  // ✅ Select all
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelected(products.map((p) => p._id));
    } else {
      setSelected([]);
    }
  };

  // // ✅ Delete single product
  // const handleDelete = async (id) => {
  //   if (!window.confirm("Are you sure to delete this Product?")) return;
  //   try {
  //     await axios.delete(`https://crm-server-htk6.vercel.app/api/products/${id}`);
  //     fetchProducts();
  //     setSelected((prev) => prev.filter((s) => s !== id));
  //   } catch (err) {
  //     console.error("❌ Error deleting product:", err);
  //   }
  // };

  // // ✅ Bulk delete
  // const handleBulkDelete = async () => {
  //   if (selected.length === 0) {
  //     alert("⚠️ Please select at least one product to delete");
  //     return;
  //   }
  //   if (!window.confirm(`Delete ${selected.length} selected products?`)) return;

  //   try {
  //     await axios.delete("https://crm-server-htk6.vercel.app/api/products", {
  //       data: { ids: selected },
  //     });
  //     setSelected([]);
  //     fetchProducts();
  //   } catch (err) {
  //     console.error("❌ Error bulk deleting products:", err);
  //   }
  // };

  return (
    <div className="page" style={{ fontFamily: "Arial, sans-serif", padding: "20px" }}>
      <h2 style={{ textAlign: "center", color: "#2a9d8f" }}>Product Management</h2>

      {/* Form */}
      <div
        className="form-container"
        style={{
          background: "#f8f9fa",
          padding: "20px",
          borderRadius: "10px",
          marginBottom: "20px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
        }}
      >
        <h3 style={{ marginBottom: "15px", color: "#264653" }}>
          {editId ? "✏️ Update Product" : "Create New Product"}
        </h3>

        <div className="form-row" style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
        <input
  type="text"
  name="productName"
  placeholder="Product Name"
  list="productOptions"       // 🔹 connect to datalist
  value={form.productName}
  onChange={handleChange}
  style={{ flex: 2, padding: "8px" }}
/>

<datalist id="productOptions">
  {products.map((p) => (
    <option key={p._id} value={p.productName} />
  ))}
</datalist>

          <input
            type="text"
            name="qty"
            placeholder="QTY"
            value={form.qty}
            onChange={handleChange}
            style={{ flex: 1, padding: "8px" }}
          />
         
        </div>

        <div
  className="form-row"
  style={{ display: "flex", gap: "10px", marginBottom: "10px" }}
>
  {/* 🔹 Active Status */}
  <select
    name="isActive"
    value={form.isActive}
    onChange={handleChange}
    style={{ flex: 1, padding: "8px" }}
  >
    <option value="">Select Status</option>
    <option value="Active">Active</option>
    <option value="Inactive">Inactive</option>
  </select>

  {/* 🔹 Counted */}
  <select
  name="isCount"
  value={form.isCount}
  onChange={handleChange}
  style={{ flex: 1, padding: "8px" }}
>
  <option value="">Select Status</option>
  <option value="Yes">Counted</option>
  <option value="No">Not Counted</option>
</select>

  {/* 🔹 Email Mandatory */}
  <select
    name="isEmailMandatory"
    value={form.isEmailMandatory}
    onChange={handleChange}
    style={{ flex: 1, padding: "8px" }}
  >
    <option value="">Select Status</option>
    <option value="Yes">Email Mandatory</option>
    <option value="No">Email Optional</option>
  </select>

  {/* 🔹 DOB Mandatory */}
  <select
    name="isDOBMandatory"
    value={form.isDOBMandatory}
    onChange={handleChange}
    style={{ flex: 1, padding: "8px" }}
  >
    <option value="">Select Status</option>
    <option value="Yes">DOB Mandatory</option>
    <option value="No">DOB Optional</option>
  </select>

  {/* 🔹 CVV Mandatory */}
  <select
    name="isCVVMandatory"
    value={form.isCVVMandatory}
    onChange={handleChange}
    style={{ flex: 1, padding: "8px" }}
  >
    <option value="">Select Status</option>
    <option value="Yes">CVV Mandatory</option>
    <option value="No">CVV Optional</option>
  </select>
</div>


        <div style={{ display: "flex", gap: "10px" }}>
          <button
            onClick={editId ? handleUpdate : handleSave}
            style={{
              background: editId ? "#e9c46a" : "#2a9d8f",
              color: "white",
              padding: "10px 16px",
              borderRadius: "6px",
              border: "none",
              cursor: "pointer",
              flex: 1,
            }}
          >
            {editId ? "✏️ Update Product" : "💾 Save Product"}
          </button>

          {editId && (
            <button
              onClick={resetForm}
              style={{
                background: "#e63946",
                color: "white",
                padding: "10px 16px",
                borderRadius: "6px",
                border: "none",
                cursor: "pointer",
                flex: 1,
              }}
            >
              ❌ Cancel
            </button>
          )}
        </div>
      </div>

      {/* List Header with Bulk Delete */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        <h3 style={{ margin: 0 }}>📋 Product List</h3>
        {/* <button
          onClick={handleBulkDelete}
          style={{
            background: selected.length > 0 ? "#e63946" : "gray",
            color: "white",
            padding: "8px 16px",
            borderRadius: "6px",
            border: "none",
            cursor: selected.length > 0 ? "pointer" : "not-allowed",
          }}
          disabled={selected.length === 0}
        >
          🗑 Delete Selected ({selected.length})
        </button> */}
      </div>

      {/* Table */}
      <div className="table-container" style={{ overflowX: "auto" }}>
        <table className="user-table" style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead style={{ background: "#f4f4f4" }}>
            <tr>
              <th>
                <input
                  type="checkbox"
                  onChange={handleSelectAll}
                  checked={products.length > 0 && selected.length === products.length}
                />
              </th>
              <th>Product Name</th>
              <th>Qty</th>
              {/* <th>Price</th>
              <th>Offer Price</th> */}
              <th>Is Active</th>
              <th>Counted</th>
              <th>Email Mandatory</th>
              <th>DOB Mandatory</th>
              <th>CVV Mandatory</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {products.length === 0 ? (
              <tr>
                <td colSpan="11" style={{ textAlign: "center", padding: "12px" }}>
                  No Products Found
                </td>
              </tr>
            ) : (
              products.map((p) => (
                <tr key={p._id} style={{ borderBottom: "1px solid #ddd" }}>
                  <td style={{ textAlign: "center" }}>
                    <input
                      type="checkbox"
                      checked={selected.includes(p._id)}
                      onChange={() => toggleSelect(p._id)}
                    />
                  </td>
                  <td>{p.productName}</td>
                  <td>{p.qty}</td>
                  {/* <td>{p.productPrice}</td>
                  <td>{p.offerPrice}</td> */}
                  <td>{p.isActive}</td>
                  <td>{p.isCount ? "Yes" : "No"}</td>
                  <td>{p.isEmailMandatory ? "Yes" : "No"}</td>
                  <td>{p.isDOBMandatory ? "Yes" : "No"}</td>
                  <td>{p.isCVVMandatory ? "Yes" : "No"}</td>
                  <td style={{ textAlign: "center" }}>
                    <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                      <button
                        onClick={() => handleEdit(p)}
                        style={{
                          background: "#457b9d",
                          color: "white",
                          border: "none",
                          padding: "5px 10px",
                          borderRadius: "4px",
                          cursor: "pointer",
                        }}
                      >
                        ✏️ Edit
                      </button>
                      {/* <button
                        onClick={() => handleDelete(p._id)}
                        style={{
                          background: "#e63946",
                          color: "white",
                          border: "none",
                          padding: "5px 10px",
                          borderRadius: "4px",
                          cursor: "pointer",
                        }}
                      >
                        🗑 Delete
                      </button> */}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Product;
